import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import {
  MdOutlineNavigateBefore,
  MdOutlineNavigateNext,
} from "react-icons/md";

const ITEMS_PER_PAGE = 3;

const AllOffers = () => {
  const [offers, setOffers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    const fetchOffers = async () => {
      try {
        const formData = new FormData();
        formData.append("page", currentPage);
        formData.append("page_size", ITEMS_PER_PAGE);

        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/cust_api/get_offer`,
          formData
        );

        if (response.data.status === 1 && Array.isArray(response.data.data)) {
          setOffers(response.data.data);
          setTotalPages(Number(response.data.total_pages) || 1);
        } else {
          setOffers([]);
        }
      } catch (error) {
        console.error("Error fetching offers:", error);
        setOffers([]);
      }
    };

    fetchOffers();
  }, [currentPage]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [currentPage]);

  const changePage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const getImageUrl = (offer) =>
    offer?.offer_img
      ? `${process.env.REACT_APP_API_URL}${offer.offer_img}`
      : "/image/property-search.jpg";

  return (
    <main className="mx-auto max-w-6xl px-4 py-10 sm:px-6">
      <header className="mb-8">
        <p className="mb-2 text-sm font-semibold uppercase tracking-wider text-orange-600">
          Special deals
        </p>
        <h1 className="text-3xl font-bold text-gray-900 sm:text-4xl">
          Featured offers
        </h1>
        <p className="mt-2 text-gray-600">
          Explore current offers on properties.
        </p>
      </header>

      {offers.length === 0 ? (
        <div className="rounded-xl border border-gray-200 bg-gray-50 px-6 py-12 text-center text-gray-600">
          No offers are available right now.
        </div>
      ) : (
        <>
          <section className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {offers.map((offer, index) => (
              <Link
                key={offer?._id || offer?.property_id || index}
                to={{
                  pathname: `/offerdetail/${offer?.property_id}`,
                  state: { offer },
                }}
                className="group overflow-hidden rounded-xl border border-gray-200 bg-white transition hover:-translate-y-1 hover:shadow-lg"
              >
                <div className="relative">
                  <img
                    src={getImageUrl(offer)}
                    alt={offer?.offer_name || "Property offer"}
                    className="h-52 w-full object-cover transition duration-300 group-hover:scale-105"
                  />
                  <span className="absolute left-3 top-3 rounded-full bg-white px-3 py-1 text-xs font-semibold text-orange-700 shadow">
                    Featured offer
                  </span>
                </div>

                <div className="flex items-center justify-between gap-3 p-4">
                  <h2 className="font-semibold text-gray-900">
                    {offer?.offer_name || "Special property offer"}
                  </h2>
                  <span className="shrink-0 text-sm font-medium text-orange-600">
                    View offer <span aria-hidden="true">→</span>
                  </span>
                </div>
              </Link>
            ))}
          </section>

          {totalPages > 1 && (
            <nav
              className="mt-8 flex items-center justify-center gap-4"
              aria-label="Offer pages"
            >
              <button
                type="button"
                onClick={() => changePage(currentPage - 1)}
                disabled={currentPage === 1}
                aria-label="Previous page"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-gray-300 text-gray-700 disabled:cursor-not-allowed disabled:opacity-40"
              >
                <MdOutlineNavigateBefore className="text-xl" />
              </button>

              <span className="text-sm text-gray-600">
                Page {currentPage} of {totalPages}
              </span>

              <button
                type="button"
                onClick={() => changePage(currentPage + 1)}
                disabled={currentPage === totalPages}
                aria-label="Next page"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-gray-300 text-gray-700 disabled:cursor-not-allowed disabled:opacity-40"
              >
                <MdOutlineNavigateNext className="text-xl" />
              </button>
            </nav>
          )}
        </>
      )}
    </main>
  );
};

export default AllOffers;
